class AbstractPrinterDriver {
  constructor(printer) {
    this.printer = printer;
  }

  async configure(config) {
    throw new Error("Not implemented yet");
  }

  async print() {
    throw new Error("Not implemented yet");
  }

}

export default AbstractPrinterDriver;